import { Space } from 'antd'
import KButton from 'app/components/Modules/General/KButton'
import Icon from 'app/components/UI-Elements/General/Icon'
import { RecordType } from 'app/constants/GlobalTypes'
import * as React from 'react'

type Props = { url: string; title: string }

const DocumentItem: React.FC<Props> = ({ url, title }) => {
  return (
    <Space wrap align="center" className="justify-content-between full-width">
      <Space size="middle" align="center">
        <Icon type="rental_quoted" />
        <p className="m-0">{title}</p>
      </Space>
      <KButton
        ellipsis
        recordType={RecordType.document}
        action="show_pdf"
        type="secondary"
        onClick={() => window.open(url)}
        disabled={!url}
      />
    </Space>
  )
}

export default DocumentItem
